
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import ToolGrid from './components/ToolGrid';
import QuickActions from './components/QuickActions';
import RecentActivity from './components/RecentActivity';
import CozeChat from '../../components/feature/CozeChat';

export default function Dashboard() {
  const [userRole, setUserRole] = useState<string>('');
  const [userName, setUserName] = useState<string>('');
  const [selectedCategory, setSelectedCategory] = useState<string>('all');
  const [isCozeChatOpen, setIsCozeChatOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    if (!isLoggedIn) {
      navigate('/login');
      return;
    }
    
    setUserRole(localStorage.getItem('userRole') || '');
    setUserName(localStorage.getItem('userName') || '');
  }, [navigate]);

  const handleLogout = () => {
    localStorage.clear();
    navigate('/login');
  };

  const handleOpenCozeChat = () => {
    setIsCozeChatOpen(true);
  };

  const handleCloseCozeChat = () => {
    setIsCozeChatOpen(false);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header userName={userName} userRole={userRole} onLogout={handleLogout} />
      
      <div className="flex">
        <Sidebar 
          selectedCategory={selectedCategory} 
          onCategoryChange={setSelectedCategory}
          userRole={userRole}
        />
        
        <main className="flex-1 p-6 ml-64">
          <div className="max-w-7xl mx-auto">
            <div className="mb-8">
              <h1 className="text-3xl font-bold text-gray-900 mb-2">
                欢迎回来，{userName}
              </h1>
              <p className="text-gray-600">
                今天是 {new Date().toLocaleDateString('zh-CN', { 
                  year: 'numeric', 
                  month: 'long', 
                  day: 'numeric',
                  weekday: 'long'
                })}
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mb-8">
              <div className="lg:col-span-3">
                <ToolGrid 
                  selectedCategory={selectedCategory} 
                  userRole={userRole}
                  onOpenCozeChat={handleOpenCozeChat}
                />
              </div>
              <div className="space-y-6">
                <QuickActions userRole={userRole} />
                <RecentActivity />
              </div>
            </div>
          </div>
        </main>
      </div>

      {/* Coze AI 对话组件 */}
      <CozeChat 
        isOpen={isCozeChatOpen} 
        onClose={handleCloseCozeChat} 
      />
    </div>
  );
}
